module.exports = __webpack_public_path__ + "static/media/piper-typing-background.667a93f1.gif";